module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/serum@2x_bf7b65.png";